import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const CALENDLY = "https://calendly.com/katie-fernands/discovery-call";

export function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-dark text-on-dark pt-36 pb-24 md:pt-44 md:pb-32">
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 55% 60% at 20% 20%, oklch(0.56 0.14 40 / 0.22), transparent 65%)",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none opacity-50"
        style={{
          background:
            "radial-gradient(circle at 90% 90%, oklch(0.63 0.035 130 / 0.18), transparent 55%)",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none opacity-[0.035] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
        }}
      />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-8">
            <motion.h1
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.05 }}
              className="text-[3.25rem] sm:text-6xl md:text-7xl lg:text-[6.5rem] font-normal tracking-tight leading-[0.98]"
            >
              Grow your book
              <br />
              <em className="italic text-sage font-normal">without</em> cold calls.
            </motion.h1>
          </div>
          <div className="lg:col-span-4 lg:pb-4">
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.15 }}
              className="text-lg md:text-xl text-white/80 leading-snug font-light border-l border-primary/60 pl-5"
            >
              A predictable pipeline, built on the trust you've already earned.
            </motion.p>
          </div>
        </div>

        <div className="mt-16 lg:mt-24 grid lg:grid-cols-12 gap-10 items-center">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.25 }}
            className="lg:col-span-7 text-base md:text-lg text-white/60 leading-relaxed max-w-xl"
          >
            You're excellent at what you do. Growth just shouldn't hinge on luck or your last golf round.
            I'll turn your network, your voice, and your point of view into an inbound engine that
            keeps working while you're on client calls.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.35 }}
            className="lg:col-span-5 flex flex-col sm:flex-row lg:justify-end items-start sm:items-center gap-4"
          >
            <a
              href={CALENDLY}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-7 py-3.5 text-base font-medium hover:opacity-90 transition-all"
            >
              Book a discovery call
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </a>
            <a
              href="#how-it-works"
              className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors border-b border-white/20 hover:border-white pb-1"
            >
              See how it works
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
